module.exports = __webpack_public_path__ + "static/media/bytt-no-8.abc41cd2.mp3";